var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "radio-group", class: _vm.inputClass },
    [
      _vm._l(_vm.options, function (option) {
        return _c("radio-input", {
          key: option.value,
          attrs: {
            label: option.label,
            value: option.value,
            disabled: _vm.disabled,
          },
          model: {
            value: _vm.currentValue,
            callback: function ($$v) {
              _vm.currentValue = $$v
            },
            expression: "currentValue",
          },
        })
      }),
      _vm.error ? _c("span", [_vm._v(_vm._s(_vm.error))]) : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }